"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BringgException_1 = require("../Core/BringgException");
var CrudService_1 = __importDefault(require("../Core/CrudService"));
var RouteGenerator_1 = require("../Core/RouteGenerator");
var Route_1 = require("../Services/Route");
var RouteOptimizationApi = /** @class */ (function () {
    function RouteOptimizationApi(session) {
        this.optimization = new Route_1.Route('/own-fleet-optimization-service/route_optimization/optimize', 1 /* HttpMethod.POST */);
        this.get_optimization_result = new Route_1.Route('/own-fleet-optimization-service/route_optimization/get_optimization_result/{:request_uuid}', 0 /* HttpMethod.GET */);
        this.cancel_requests = new Route_1.Route('/own-fleet-optimization-service/route_optimization/optimization', 4 /* HttpMethod.DELETE */);
        this.assign_users_by_ids = new Route_1.Route('/route_optimizations/assign_users_by_ids', 1 /* HttpMethod.POST */);
        this.assign_users_by_ids_in_background_process = new Route_1.Route('/own-fleet-optimization-service/route_optimization/assign_users_by_ids', 1 /* HttpMethod.POST */);
        this.update_user_modified_data = new Route_1.Route('/own-fleet-optimization-service/route_optimization/update_user_modified_data', 1 /* HttpMethod.POST */);
        this.assign_user_manual_optimization = new Route_1.Route('/route_optimizations/assign_user_manual_optimization', 1 /* HttpMethod.POST */);
        this.service = new CrudService_1.default(session, '');
    }
    RouteOptimizationApi.prototype.cancelRequests = function (requestUuids) {
        return this.service.handleAuthorizedRequest({
            route: this.cancel_requests,
            extractor: RouteGenerator_1.defaultExtractor,
            exceptionProducer: BringgException_1.BringgException.serviceException('Failed to call cancel optimization requests'),
            queryString: { request_uuids: requestUuids }
        });
    };
    RouteOptimizationApi.prototype.optimize = function (optimizationProps) {
        return this.service.handleAuthorizedRequest({
            route: this.optimization,
            extractor: RouteGenerator_1.defaultExtractor,
            exceptionProducer: BringgException_1.BringgException.serviceException('Failed to call optimization requests'),
            payload: optimizationProps
        });
    };
    RouteOptimizationApi.prototype.optimizationResult = function (request_uuid) {
        return this.service.handleAuthorizedRequest({
            route: this.get_optimization_result,
            extractor: RouteGenerator_1.defaultExtractor,
            exceptionProducer: BringgException_1.BringgException.serviceException('Failed to get optimization results'),
            routeParams: { request_uuid: request_uuid }
        });
    };
    RouteOptimizationApi.prototype.assignUsersByIds = function (teams, isBackgroundProcess) {
        var fiveMinutesInMs = 1000 * 60 * 5;
        return this.service.handleAuthorizedRequest({
            route: isBackgroundProcess ? this.assign_users_by_ids_in_background_process : this.assign_users_by_ids,
            extractor: RouteGenerator_1.defaultExtractor,
            exceptionProducer: BringgException_1.BringgException.serviceException('Failed to assign users by id'),
            payload: { origin: 'route_optimization', teams: teams },
            timeout: fiveMinutesInMs
        });
    };
    RouteOptimizationApi.prototype.updateOptimizationModifiedData = function (updateData) {
        return this.service.handleAuthorizedRequest({
            route: this.update_user_modified_data,
            extractor: RouteGenerator_1.defaultExtractor,
            exceptionProducer: BringgException_1.BringgException.serviceException('Failed to update optimization user data'),
            payload: __assign({}, updateData)
        });
    };
    RouteOptimizationApi.prototype.assignUserManualOptimization = function (updateData) {
        var fiveMinutesInMs = 1000 * 60 * 5;
        return this.service.handleAuthorizedRequest({
            route: this.assign_user_manual_optimization,
            extractor: RouteGenerator_1.defaultExtractor,
            exceptionProducer: BringgException_1.BringgException.serviceException('Failed to assign user manual optimization data'),
            payload: __assign({}, updateData),
            timeout: fiveMinutesInMs
        });
    };
    RouteOptimizationApi.prototype.calculatePlannedEta = function (data, _a) {
        if (_a === void 0) { _a = {}; }
        var _b = _a.timeout, timeout = _b === void 0 ? 10000 : _b, options = __rest(_a, ["timeout"]);
        return __awaiter(this, void 0, void 0, function () {
            var payload, result, asyncResult;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        payload = {
                            team_id: data.team_id,
                            data: __assign(__assign({}, data), { deadline: Date.now() + timeout })
                        };
                        return [4 /*yield*/, this.service.routeGenerator
                                .post('/own-fleet-optimization-service/route_optimization/calculate_planned_eta')
                                .withPayload(payload)
                                .setException('Failed to calculate planned eta')
                                .withCommonOptions(options)
                                .invoke()];
                    case 1:
                        result = _c.sent();
                        return [4 /*yield*/, this.service.session.sdk.asyncOperationStatus.waitForResponse({
                                requestId: result.uuid,
                                timeoutInMs: timeout,
                                signal: options.signal
                            })];
                    case 2:
                        asyncResult = _c.sent();
                        return [2 /*return*/, asyncResult.data];
                }
            });
        });
    };
    return RouteOptimizationApi;
}());
exports.default = RouteOptimizationApi;
//# sourceMappingURL=RouteOptimizationApi.js.map